class IncomeStatement {
	constructor(
		revenue,
		openingInventory,
		purchases,
		closingInventory,
		lostInventory,
		costOfGoodsSold,
		grossProfit,
		expenses,
		netProfit,
	) {
		this.revenue = revenue;
		this.openingInventory = openingInventory;
		this.purchases = purchases;
		this.closingInventory = closingInventory;
		this.lostInventory = lostInventory;
		this.costOfGoodsSold = costOfGoodsSold;
		this.grossProfit = grossProfit;
		this.expenses = expenses;
		this.netProfit = netProfit;
	}

	toPlainObj() {
		return {
			revenue: this.revenue,
			openingInventory: this.openingInventory,
			purchases: this.purchases,
			closingInventory: this.closingInventory,
			lostInventory: this.lostInventory,
			costOfGoodsSold: this.costOfGoodsSold,
			grossProfit: this.grossProfit,
			expenses: this.expenses,
			netProfit: this.netProfit,
		};
	}
};

export default function IncomeStatementBuilder() {
	return {
		withRevenue: function (revenue) {
			this.revenue = revenue;
			return this;
		},
		withOpeningInventory: function (openingInventory) {
			this.openingInventory = openingInventory;
			return this;
		},
		withPurchases: function (purchases) {
			this.purchases = purchases;
			return this;
		},
		withClosingInventory: function (closingInventory) {
			this.closingInventory = closingInventory;
			return this;
		},
		withLostInventory: function (lostInventory) {
			this.lostInventory = lostInventory;
			return this;
		},
		withCostOfGoodsSold: function (costOfGoodsSold) {
			this.costOfGoodsSold = costOfGoodsSold;
			return this;
		},
		withGrossProfit: function (grossProfit) {
			this.grossProfit = grossProfit;
			return this;
		},
		withExpenses: function (expenses) {
			this.expenses = expenses;
			return this;
		},
		withNetProfit: function (netProfit) {
			this.netProfit = netProfit;
			return this;
		},
		build: function () {
			return new IncomeStatement(
				this.revenue,
				this.openingInventory,
				this.purchases,
				this.closingInventory,
				this.lostInventory,
				this.costOfGoodsSold,
				this.grossProfit,
				this.expenses,
				this.netProfit,
			);
		}
	};
}

export function getNewEmptyIncomeStatementObj() {
	return new IncomeStatementBuilder()
		.withRevenue(0)
		.withOpeningInventory(0)
		.withPurchases(0)
		.withClosingInventory(0)
		.withLostInventory(0)
		.withCostOfGoodsSold(0)
		.withGrossProfit(0)
		.withExpenses(0)
		.withNetProfit(0)
		.build()
		.toPlainObj();
}
